import type { AnnouncementEventType } from '@api';
import type { ScheduleEventData } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { PayloadType } from '../../../../types';

type GetAnnouncementTitleType = (
  artistName: string,
  tourName: string
) => string;

type GetScheduledEventFromAnnouncementDataReturnType =
  ScheduleEventData<PayloadType>[];

export const getScheduledEventFromAnnouncementData = (
  records: AnnouncementEventType[],
  getAnnouncementTitle: GetAnnouncementTitleType
): GetScheduledEventFromAnnouncementDataReturnType => {
  return records.map((announcement) => {
    const title = getAnnouncementTitle(
      announcement.artist.name,
      announcement.tour.name
    );
    return {
      id: `announcement-${announcement.artist.id}-${announcement.tour.id}-${announcement.date}`,
      title,
      start: dayjs(announcement.date).format('YYYY-MM-DD 00:00:00'),
      end: dayjs(announcement.date)
        .add(1, 'day')
        .format('YYYY-MM-DD 00:00:00'),
      color: '#006400',
      payload: {
        type: 'ANNOUNCEMENT',
        announcement,
      },
    };
  });
};
